module.exports = __webpack_public_path__ + "img/orders.43666c3a.svg";